export default "__VITE_ASSET__Nc7I5Evr__"